import { render, staticRenderFns } from "./DiaryEntries.vue?vue&type=template&id=a2823d9e&scoped=true"
import script from "./DiaryEntries.vue?vue&type=script&lang=js"
export * from "./DiaryEntries.vue?vue&type=script&lang=js"
import style0 from "./DiaryEntries.vue?vue&type=style&index=0&id=a2823d9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2823d9e",
  null
  
)

export default component.exports